<template>
  <input
    class="form-control"
    type="text"
    :value="value"
    ref="product-options-input"
    @input="updateSelf($event.target.value)"
    @keyup="onKeyup($event.target.value)"
    >
</template>
<script>
import autoComplete from "js-autocomplete"
export default {
  name: "SearchInput",
  props: ['items', 'value'],
  data: () => ({
    autoComplete: "",
  }),
  watch: {
    items() {
      this.initAutocompleteProductNames(this.items, this.updateSelf, this.onKeyup);
    }
  },
  mounted() {

  },
  destroyed() {
    if (this.autoComplete.destroy) {
      this.autoComplete.destroy();
    }
  },
  methods: {
    updateSelf(val) {
      this.$emit('input', val)
    },
    onKeyup(val) {
      this.$emit('onSearchInputKeyup', val)
    },
    initAutocompleteProductNames: function(names, onSelectCallback, onKeyupCallback) {
      this.autoComplete = new autoComplete({
          selector: this.$refs['product-options-input'],
          minChars: 2,
          source: function(term, suggest){
              term = term.toLowerCase();
              var choices = names;
              var matches = [];
              for (var i=0; i<choices.length; i++)
                  if (~choices[i].toLowerCase().indexOf(term)) matches.push(choices[i]);
              suggest(matches);
          },
          onSelect: function(e, term, item){
              onSelectCallback(item.getAttribute('data-val'));
              onKeyupCallback(item.getAttribute('data-val'));
          }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/utils/SearchInput.vue